import { Select, Text, VStack } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { useStores } from "../../store/store_context";

const SelectTypeProfit = observer(() => {
  const { pageStore } = useStores();

  return (
    <VStack
    >
      <Select
        style={{
          border: "none",
          background: "#333",
          color: "#EEEEEE",
          borderRadius: "10px",
          fontWeight: 600,
          fontSize:"14px"
        }}
        width={"250px"}
        value={pageStore.selected_view_profit}
        onChange={(e) => {
          const selectedValue = e.target.value;
          pageStore.updateSelectedViewProfit(selectedValue);
        }}
      >
        <option value="manager-deals" style={{ background: "#0C0C0C", color: "#EEEEEE" }}>Менеджер — Сделки</option>
        <option value="manager-partner" style={{ background: "#0C0C0C", color: "#EEEEEE" }}>Менеджер — Контрагенты</option>
        <option value="partner-manager" style={{ background: "#0C0C0C", color: "#EEEEEE" }}>Контрагенты — Менеджер</option>
        <option value="producer-manager" style={{ background: "#0C0C0C", color: "#EEEEEE" }}>Производитель — Менеджер</option>
        <option value="manager-producer" style={{ background: "#0C0C0C", color: "#EEEEEE" }}>Менеджер — Производитель</option>
        <option value="producer-producer" style={{ background: "#0C0C0C", color: "#EEEEEE" }}>Производитель</option>
        <option value="partner-partner" style={{ background: "#0C0C0C", color: "#EEEEEE" }}>Контрагенты</option>
        <option value="departament-manager" style={{ background: "#0C0C0C", color: "#EEEEEE"}}>ОП с РОПом</option>
        <option value="departament-manager-withoutROP" style={{ background: "#0C0C0C", color: "#EEEEEE"}}>ОП без РОПа</option>
        <option value="partner-deals" style={{ background: "#0C0C0C", color: "#EEEEEE" }}>Контрагенты — Сделки</option>
        <option value="deal" style={{ background: "#0C0C0C", color: "#EEEEEE" }}>Сделки</option>
      </Select>
    </VStack>
  );
});

export default SelectTypeProfit;
